export const ROLE = {
    none: 'none',
    author: 'Autor',
    vendor: 'PRO',
};
